<template>
    <div class="t_group">
        <div class="t_group_head" :style='group.style'>
<!--            {this.state.selectedFlag && this.props.selectItem && (-->
<!--            <label class="t_cell-select_label emul-check" onClick={(e) => {-->
<!--            e.target.closest('.t_group').querySelector('.t_group_body').querySelectorAll('.t_cell-select_input').forEach(input => {-->
<!--            let f = e.target.checked;-->
<!--            input.checked = f;-->
<!--            this.props.selectItem(+input.dataset.id,f)-->

<!--            if(!f) this.head.current.querySelector('.t_cell-select_input').checked = false;-->
<!--            })-->
<!--            }}>-->
<!--            <input type="checkbox" class="t_cell-select_input t_cell-select_input-group" />-->
<!--            <span>-->
<!--                        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                          <path d="M1 4L4.5 7.5L11 1" stroke="#2C2A44" strokeWidth="2"></path>-->
<!--                        </svg>-->
<!--                      </span>-->
<!--            </label>-->
<!--            )}-->

            <select-checkbox-component :value="groupKey" @toggle="toggleAllSelect" />

            <span class="t_group_head_text">
                {{ group.value }} ({{ group.total}})
            </span>
        </div>
        <div class="t_group_body">
            <div class="t_row" v-for="(row, index) in group.data">
                <RowComponent v-for="(column, columnKey) in row" :key="`group-row-${groupKey}-${columnKey}`"
                              @toggle="toggleSelect"
                              @deleteItem="deleteItem(column.value)"
                              :column-key="columnKey" :column="column" :is-current-season-selected="isCurrentSeasonSelected"/>
            </div>
        </div>
    </div>
</template>

<script>
import SelectCheckboxComponent from "./SelectCheckboxComponent";
import RowComponent from "./RowComponent";

export default {
    name: "GroupComponent",

    components: {RowComponent, SelectCheckboxComponent},

    props: ['group', 'groupKey', 'isCurrentSeasonSelected'],

    data: function () {
        return {
            selected: [],
        };
    },

    methods: {
        toggleAllSelect(value,checked) {
            if(checked === false) {
                console.log('unselect');
                let selected = [];

                this.selected.forEach((id) => selected.push(id));

                for(let i = 0; i < selected.length; i++) {
                    this.$eventBus.$emit('select-checkbox', selected[i], false);
                }
            } else {
                console.log('select');
                this.group.data.forEach((item) => {
                    if(item.selectCheckbox) {
                        this.$eventBus.$emit('select-checkbox', item.selectCheckbox.value, true);
                    }
                });
            }
        },

        toggleSelect(id, status) {

            let index = this.selected.indexOf(id);

            if(status) {
                if(index === -1) {
                    this.selected.push(id);
                     this.$emit('toggle', id, status);
                }
            } else {
                if(index !== -1) {
                    this.selected.splice(index, 1);
                     this.$emit('toggle', id, status);
                }
            }
        },
        deleteItem(id) {
            this.$emit('deleteItem', id)
        }
    }
}
</script>
